/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import SimpleInput from '/client/src/components/forms/simpleInput';
import { CTooltip, CTooltipLabel, CTooltipText } from '/client/src/components/tooltip/';
import TagsInput from 'react-tagsinput';
import _ from 'lodash';

type PropsType = {
  value?: {
    applied_to_ticket_id: [],
    display_type: string,
    help_text: string,
    is_required: boolean,
    options: [],
    ask_to: string,
    text: string,
    isNew?: boolean,
    id?: string | number,
    temp_id?: string | number
  },
  data: {
    index: number | string,
    items: [],
    handleControlEventQuestion: () => void,
    tickets: [],
    questions: []
  },
  id?: string | number,
  index: number | string
};

class QItem extends React.PureComponent<PropsType> {
  props: PropsType;

  constructor(props: PropsType) {
    super(props);
    this.responseValidationMsg = React.createRef<HTMLDevElement>(null);

    this.initAppliedTempTicketIds = (): any => {
      const tickets = _.get(props, 'data.tickets', []);
      const appliedTickets = _.get(props, 'value.applied_to_ticket_id', []);

      if (!_.size(appliedTickets)) {
        return [];
      }
      const tempTickets = tickets.filter(x => appliedTickets.includes(x.id));

      return tempTickets.map(el => el.temp_id);
    };

    this.state = {
      id: props.value.id,
      temp_id: props.value.temp_id,
      tickets: _.get(props, 'data.tickets', []),
      appliedTickets: props.value && _.get(props, 'value.applied_to_ticket_id', []),
      appliedTempTickets: this.initAppliedTempTicketIds(),
      applied_to_ticket_temp_id: _.get(props, 'value.applied_to_ticket_temp_id', this.initAppliedTempTicketIds()),
      applied_to_all_tickets: _.get(props, 'value.applied_to_all_tickets', false),
      questionType: props.value.display_type || '',
      helpText: props.value.help_text || '',
      tags: _.size(props.value.options) ? _.map(props.value.options, (o: {}): string => o.text) : [],
      isRequired: _.get(props, 'value.is_required', false),
      askTo: props.value.ask_to || 'Purchaser',
      label: props.value.text || '',
      isSelectedAll: true
    };

    this.singleQuestionObjIndex = 0;

    _.find(this.state.questions, (l: {}, li: number): {} => {
      if (+l.id === +props.id) {
        this.singleQuestionObjIndex = li;

        return l;
      }
    });
  }

  setQuestions = () => {
    const { data: { questions, handleControlEventQuestion }, value: { isNew } } = this.props;
    const {
      id,
      label,
      appliedTickets,
      appliedTempTickets,
      askTo,
      questionType,
      helpText,
      isRequired,
      tags
    } = this.state;

    let _questions = _.clone(questions);

    _questions = _.map(_questions, (_q: {}): {} => {
      if ((_.toString(_q.id) === _.toString(id))) {
        return {
          ..._q,
          text: label,
          applied_to_ticket_id: appliedTickets,
          applied_to_ticket_temp_id: appliedTempTickets,
          ask_to: askTo,
          display_type: questionType,
          help_text: helpText,
          is_required: isRequired,
          options: _.map(tags, (t: string): {} => ({ text: t })),
          isNew: false,
          focused: true
        };
      }

      return {
        ..._q,
        focused: false
      };
    });
    handleControlEventQuestion(_.compact(_questions));
  };

  setApliedTickets = (appliedTickets: []) => {
    const { tickets } = this.state;
    const tempTickets = tickets.filter(x => appliedTickets.includes(x.id));
    const tempIds = tempTickets.map(el => el.temp_id);
    const allIds = _.map(_.get(this.props, 'data.tickets', []), (t: {}): number => t.id);


    this.setState({
      isSelectedAll: _.isEqual(allIds.sort(), appliedTickets.sort()),
      appliedTempTickets: tempIds,
      appliedTickets
    });
  };

  handleChangeType = (questionType: string) => {
    this.setState({
      questionType
    });
  };

  handleChangeHelpText = (helpText: string) => {
    this.setState({ helpText });
  };

  setIsRequired = (isRequired: boolean) => {
    this.setState({ isRequired }, () => {
      this.setQuestions();
    });
  };

  setAskTo = (askTo: string) => {
    this.setState({ askTo });
  };

  setLabel = (label: string) => {
    this.setState({ label });
  };

  handleChange = (_tags: []) => {
    this.setState({ tags: _.filter(_tags, (i: string): boolean => i.trim() !== '') });
  }

  handleSelectAll = () => {
    const tIds = _.map(_.get(this.props, 'data.tickets', []), (t: {}): number => t.id);

    if (_.isEqual(tIds, this.state.appliedTickets)) {
      this.setApliedTickets([]);
    } else {
      this.setApliedTickets(tIds);
    }

    // Hack for blur
    setTimeout(() => {
      this.setQuestions();
    }, 1000);
  };

  render(): React.Fragment {
    const {
      tickets,
      appliedTickets,
      askTo,
      isRequired,
      label,
      questionType,
      helpText,
      tags,
      temp_id,
      id,
      isSelectedAll
    } = this.state;

    const randomIndex = _.random(1, Date.now());
    const appliedTicketsStringed = _.size(appliedTickets) ? appliedTickets.map(el => el.toString()) : [];

    return (
    <div className='QuestionLevelItem' data-tli={temp_id || id}
      onBlur={(event: any) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          this.setQuestions();
        }
    }}
    >
        <div className="form-group SimpleInput">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group SimpleInput">
                <label>Question Type</label>
                <select
                  className="form-control styled-select"
                  onChange={(e: any) => {
                    this.handleChangeType(e.target.value);
                  }}
                  value={questionType}
                >
                  <option
                    value="TextBox"
                  >Text Box</option>
                  <option
                    value="DropdownList"
                  >Dropdown List</option>
                  <option
                    value="CheckBox"
                  >Checkbox</option>
                </select>
              </div>
            </div>

            <div className="col-sm-6">
              <SimpleInput
                name={`label-QItem-${this.props.data.index}-${randomIndex}`}
                id={`label-QItem-${this.props.data.index}-${randomIndex}`}
                label={
                  <>
                    Question Label
                    <CTooltip>
                      <CTooltipLabel standart>?</CTooltipLabel>
                      <CTooltipText>E.g. what size t-shirt do you want?</CTooltipText>
                    </CTooltip>
                  </>
                }
                onChange={(e: any) => {
                  this.setLabel(e.target.value);
                }}
                value={label}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <label>Applies to</label>
              <div className="dropdown dropdown-tickets">
                <button
                  className="btn btn-default dropdown-toggle"
                  style={{ width:'100%' }}
                  type="button"
                  onClick={(e) => {
                    $(e.target.closest('.dropdown-tickets')).toggleClass('open');
                  }}
                >
                  <div style={{ cursor: 'pointer', textAlign: 'left' }}>
                    {_.size(appliedTickets) === _.size(tickets) ?
                      <>All Tickets</> :
                      <>{
                        _.size(appliedTickets) === 1 ?
                          <>{_.map(tickets, (t: {}): string => {
                            if (t.id.toString() === (appliedTickets)[0].toString()) {
                              return t.name;
                            }
                          })}</> :
                          <>
                            {_.size(appliedTickets) === 0 ?
                              <></> :
                              <>{_.size(appliedTickets)} tickets</>
                            }
                          </>
                      }</>
                    }
                    <span className="caret-right">
                      <span className="caret" />
                    </span>
                  </div>
                </button>
              <ul className="dropdown-menu" role="menu" style={{ width:'100%' }}
                tabIndex={3}
              >
                  <li onClick={this.handleSelectAll}>
                    <a>{isSelectedAll ? 'Clear All' : 'All Tickets'}</a>
                  </li>
                  <li role="separator" className="divider" />
                  {_.map(tickets, (t: {}, ti: number): React.Element<'li'> => {
                    return (
                      <li key={`${t.id}-${ti}`}>
                        <a title={t.name}>
                          <label className="icheckbox" style={{ margin: '6px 0' }}>
                            <input
                              checked={_.includes(appliedTicketsStringed, _.toString(t.id))}
                              type="checkbox"
                              id={`${t.id}-${randomIndex}`}
                              onChange={(e: any) => {
                                const isChecked = e.target.checked;

                                if (isChecked) {
                                  const _value = [...appliedTickets, t.id];

                                  this.setApliedTickets(_value);
                                } else {
                                  const arr = _.remove(appliedTickets, (n: string): string => {
                                    return n.toString() !== t.id.toString();
                                  });

                                  this.setApliedTickets(arr);
                                }
                              }}
                            />
                            <i className="icheckbox-icon" />
                            <span data-bind="text:name">{t.name}</span>
                          </label>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-sm-6">
              <SimpleInput
                name={`help-QItem-${this.props.data.index}-${randomIndex}`}
                id={`help-QItem-${this.props.data.index}-${randomIndex}`}
                label='Help Text'
                value={helpText}
                onChange={(e: any) => {
                  this.handleChangeHelpText(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="hidden-sm hidden-lg hidden-md" style={{ height: '10px' }} />
            <div className="col-sm-6">
              <label>Display options</label>
              <select
                className="form-control styled-select"
                value={askTo}
                onChange={(e: any) => {
                  this.setAskTo(e.target.value);
                }}
              >
                <option value="Purchaser">Ask only purchaser</option>
                <option value="Attendee">Ask each attendee</option>
              </select>
            </div>
            <div className="col-sm-6">
              {questionType !== 'TextBox' &&
              <div>
                <label style={{ fontWeight: 'normal' }}>
                  Response
                  <CTooltip>
                    <CTooltipLabel standart>?</CTooltipLabel>
                    <CTooltipText>E.g. choice1, choice2, choice3</CTooltipText>
                  </CTooltip>
                </label>

                <TagsInput
                  value={tags}
                  onChange={(tags) => this.handleChange(tags)}
                  addOnBlur
                  addKeys={[9, 13, 188]}
                  inputProps={{
                    placeholder: ''
                  }}
                />

                <div ref={this.responseValidationMsg} className="vMsg" style={{ display: 'none' }}>This field is required.</div>
              </div>
              }
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <br/>
              <label className="icheckbox" style={{ margin: '6px 0' }}>
                <input
                  type="checkbox"
                  checked={isRequired}
                  onChange={(e: any) => {
                    const isChecked = e.target.checked;

                    this.setIsRequired(isChecked);
                  }}
                />
                <i className="icheckbox-icon" />
                <span>Required Question</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default QItem;
